import { ReactNode } from 'react';
import cn from 'classnames';

//Components
import Bubbles, { BubblesType } from '~components/Bubbles';
import LandingLink from '~components/LandingLink';
//Icons
import FailIndicatorIcon from '~icons/FailIndicatorIcon';
import LogoIcon from '~icons/LogoIcon';
import SuccessIndicatorIcon from '~icons/SuccessIndicatorIcon';
import WaitingRoomTalentSignUpIcon from '~icons/WaitingRoomTalentSignUpIcon';
//Config



export type ResultScreenResultType = 'success' | 'fail';

interface IResultScreenProps {
    result: ResultScreenResultType
    title?: ReactNode
    children: ReactNode
    className?: string
}

export default function ResultScreen({result, children, title, className}: IResultScreenProps) {
    return (
        <div
            className={cn('result-screen', className, {
                'result-screen--success': result === 'success',
                'result-screen--fail': result === 'fail'
            })}
        >
            <div className="result-screen__head">
                <LandingLink><LogoIcon/></LandingLink>
            </div>

            <div className="result-screen__body">
                <div className="result-screen__indicator">
                    {result === 'success' && <SuccessIndicatorIcon/>}
                    {result === 'fail' && <FailIndicatorIcon/>}
                </div>

                {title && <h1 className="result-screen__title">{title}</h1>}

                <div className="result-screen__content">
                    {children}
                </div>
            </div>

            <div className="result-screen__footer">
                <WaitingRoomTalentSignUpIcon/>
            </div>

            <Bubbles type={BubblesType.ADVANCED}/>
        </div>
    );
}

